import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';

@Component({
    selector: 'app-elevate-confirmation',
    templateUrl: './elevate-confirmation.component.html',
    styleUrls: ['./elevate-confirmation.component.scss'],
    standalone: false
})
export class ElevateConfirmationComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private activeModal = inject(NgbActiveModal);


  @Input() message: string;
  username: string;

  ngOnInit(): void {
    if (this.message == undefined)
      this.message = "WARNING! You are going to do something out of limit!"
  }

  setConfirmation(bool: boolean) {
    if (bool == true) {
      if (this.username === sessionStorage.getItem("username"))
        this.activeModal.close(true);
      else
        this.sharedService.openAlert("Wrong username entered!", ALERT_TYPE.DANGER);
    } else {
      this.activeModal.close(false);
    }
  }
}
